import React from 'react';
import {
    HomeOutlined,
    SearchOutlined,
    UserOutlined,
    SettingOutlined,
    PlusOutlined,
    CloseOutlined,
    MenuOutlined,
    ArrowLeftOutlined,
    ArrowRightOutlined
} from '@ant-design/icons';

/**
 * UIIcon - Icon atom component
 */
const UIIcon = ({
    icon = 'home',
    size = 24,
    color = 'neutral',
    tokens
}) => {
    // Map color name to actual color value
    const getColor = () => {
        if (color.startsWith('#')) return color;
        const tokenColor = tokens?.colors?.find(c => c.name === color);
        return tokenColor?.value || '#c9d1d9';
    };

    // Map icon name to Ant Design icon
    const ICON_MAP = {
        home: HomeOutlined,
        search: SearchOutlined,
        user: UserOutlined,
        settings: SettingOutlined,
        plus: PlusOutlined,
        close: CloseOutlined,
        menu: MenuOutlined,
        'arrow-left': ArrowLeftOutlined,
        'arrow-right': ArrowRightOutlined
    };

    const IconComponent = ICON_MAP[icon] || HomeOutlined;

    return (
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <IconComponent style={{
                fontSize: size,
                color: getColor()
            }} />
        </div>
    );
};

export default UIIcon;
